import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import TopNav from './TopNav';
import { routeEntries } from './links';
import { actions } from '+/nav/navSlice';
import history from '#/history';

import logo from '../../logo.png';


const drawerWidth = 220;
const isNotProd = /staging|localhost/i.test(window.location.hostname);
const envColor = {
    'portal.upm-utils-staging.com': '#c66',
    'localhost': '#070'
};

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex'
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    menuButton: {
        marginRight: theme.spacing(2)
    },
    hide: {
        display: 'none'
    },
    title: {
        flexGrow: 1,
        textAlign: 'center'
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0
    },
    drawerPaper: {
        width: drawerWidth,
        backgroundColor: isNotProd ? envColor[window.location.hostname] : theme.palette.secondary.main,
        color: '#fff'
    },
    logo: {

        backgroundImage: `url(${logo})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'center',
        height: '150px',
        marginTop: '150px'
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end'
    },

    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        marginLeft: -drawerWidth
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: 0
    },
    menuText: {
        fontWeight: '600',
        fontSize: '13px'
    },
    nested: {
        paddingLeft: theme.spacing(4)
    }
}));

const SideNav = props => {

    const {
        toggleSidebar, open, activeMenuItem, menuItemIndex, role
    } = props;

    const classes = useStyles();
    const theme = useTheme();

    const routes = routeEntries(role);


    const handleMenuClick = (route, index) => {

        if (route.children) {

            const newIndex = menuItemIndex === index ? -1 : index;
            activeMenuItem(newIndex);

            return;
        }

        activeMenuItem(index);
        history.push(route.href);
    };

    return (
        <div className={classes.root}>
            <CssBaseline />
            <TopNav />
            <Drawer
                className={classes.drawer}
                variant='persistent'
                anchor='left'
                open={open}
                classes={{
                    paper: classes.drawerPaper
                }}
            >
                <div className={classes.drawerHeader}>
                    <IconButton onClick={toggleSidebar}>
                        {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </div>
                <Divider />
                <List>
                    {routes.map((route, index) => (
                        <React.Fragment key={index}>
                            <ListItem
                                selected={menuItemIndex === index}
                                button
                                key={route.title}
                                onClick={() => handleMenuClick(route, index)}>
                                <ListItemIcon >
                                    {route.icon}
                                </ListItemIcon>
                                <ListItemText classes={{ primary: classes.menuText }} primary={route.title} />
                                {route.children && menuItemIndex === index && <ExpandLess />}
                                {route.children && menuItemIndex !== index && <ExpandMore />}
                            </ListItem>
                            {
                                route.children && (
                                    <Collapse in={route.children && menuItemIndex === index} timeout='auto' unmountOnExit>
                                        <List component='div' disablePadding>
                                            {route.children.map((child, i) => (
                                                <ListItem key={`dropdown-${i}`} button className={classes.nested} onClick={() => history.push(child.href)}>
                                                    <ListItemText classes={{ primary: classes.menuText }} primary={child.title} />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Collapse>
                                )
                            }
                        </React.Fragment>
                    ))}
                    <ListItem className={classes.logo}/>
                </List>
            </Drawer>
            {/* {open && <Logo />} */}
            <main className={clsx(classes.content, { [classes.contentShift]: open })}>
                <div className={classes.drawerHeader} />
                {props.children}
            </main>
        </div>
    );
};

const mapStateToProps = state => ({
    role: state.auth.role,
    permissions: state.auth.permissions,
    open: state.sidebar.visible,
    menuItemIndex: state.sidebar.menuItemIndex
});


export default connect(mapStateToProps, actions)(SideNav);
